const C = require("../constants");

const partialOpenBoxDialog = (data) => {
    return {
        type: C.PARTIAL_OPEN_BOX_DIALOG,
        data
    }
};

export {partialOpenBoxDialog};


// WEBPACK FOOTER //
// ./src/actions/PartialOpenBoxDialogActions.js